import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Snippet = ({
  height = 16,
  width = 16,
  color = colors.purple90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 16 16" {...props}>
    <path
      d="M14.125 13.6892C14.125 13.9213 14.0328 14.1438 13.8687 14.3079C13.7046 14.472 13.4821 14.5642 13.25 14.5642H2.75C2.51794 14.5642 2.29538 14.472 2.13128 14.3079C1.96719 14.1438 1.875 13.9213 1.875 13.6892V2.31421C1.875 2.08214 1.96719 1.85958 2.13128 1.69549C2.29538 1.5314 2.51794 1.43921 2.75 1.43921H11.5262C11.7547 1.43924 11.9741 1.52863 12.1376 1.68829L13.8613 3.36946C13.9449 3.45102 14.0112 3.54846 14.0565 3.65606C14.1018 3.76366 14.1251 3.87922 14.125 3.99596V13.6892Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.125 5.81415H6.6875C6.47166 5.79949 6.25875 5.87052 6.09495 6.01183C5.93115 6.15314 5.82966 6.35333 5.8125 6.56898V7.29639C5.80897 7.42616 5.77104 7.55265 5.70257 7.66294C5.6341 7.77322 5.53756 7.86334 5.42283 7.92406L4.5 8.45489L5.42283 8.98515C5.53749 9.04596 5.63396 9.1361 5.70241 9.24637C5.77087 9.35663 5.80886 9.48308 5.8125 9.61281V10.3408C5.82966 10.5564 5.93117 10.7565 6.09499 10.8978C6.25881 11.039 6.47172 11.1099 6.6875 11.0951H7.125"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.875 5.81418H9.3125C9.52837 5.79937 9.74136 5.87035 9.9052 6.01169C10.069 6.15303 10.1705 6.35331 10.1875 6.56902V7.29643C10.191 7.42619 10.229 7.55269 10.2974 7.66298C10.3659 7.77326 10.4624 7.86338 10.5772 7.9241L11.5 8.45493L10.5772 8.98518C10.4625 9.046 10.366 9.13614 10.2976 9.2464C10.2291 9.35667 10.1911 9.48312 10.1875 9.61285V10.3408C10.1703 10.5565 10.0688 10.7566 9.90501 10.8978C9.74119 11.039 9.52828 11.1099 9.3125 11.0951H8.875"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
